import React, { useRef } from "react";
import { Box, Card } from "@curves/ui-base";
import useEChart from "@util/hook/useEChart";
import ChartSkeletonLoading from "@icoach/dashboard/ChartSkeletonLoading";

const generateHeatmapMockData = () => {
	const data = [];
	const days = 7;
	const hours = 24;
	for (let day = 0; day < days; day++) {
		// 每一天有自己的「熱度係數」
		const dayFactor = 0.8 + Math.random() * 0.6; // 0.8 ~ 1.4
		const isWeekend = day >= 5;

		for (let hour = 0; hour < hours; hour++) {
			// 每個小時一個基礎亂數
			let base = Math.random() * 24;

			// 時段權重（但每次都浮動）
			if (hour >= 6 && hour <= 9) {
				base += 15 + Math.random() * 10; // 早上
			} else if (hour >= 10 && hour <= 13) {
				base += 30 + Math.random() * 15; // 中午
			} else if (hour >= 17 && hour <= 20) {
				base += 45 + Math.random() * 20; // 晚上高峰
			} else if (hour >= 21 && hour <= 22) {
				base += 20 + Math.random() * 10; // 晚間
			} else {
				base += Math.random() * 5; // 深夜
			}
			// 週末加權（也帶隨機）
			const weekendBoost = isWeekend ? 1.1 + Math.random() * 0.3 : 1;
			const value = Math.round(base * dayFactor * weekendBoost);
			data.push([hour, day, value]);
		}
	}
	return data;
};

/********* 入場時間分佈熱點 *********/
const MemberCheckInHeatmap = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
            axis: {
                xLabels: Array.from({ length: 24 }, (_, i) => i),
                yLabels: ["週一", "週二", "週三", "週四", "週五", "週六", "週日"],
            },
			series: { data: generateHeatmapMockData(), recordTime: "2025/12/01 ~ 2025/12/07" },
		},
	} = props;
	const { series = {}, axis = {} } = sourceData;
	const xLabels = axis?.xLabels ?? [];
	const yLabels = axis?.yLabels ?? [];
	const seriesData = series?.data ?? [];
	const recordTime = series?.recordTime ?? "";
	const isLoading = seriesData.length === 0;
	const title = "入場時間分佈熱點";
	const subTitle = "一週入場人流分佈趨勢";
	const option = {
		title: {
			text: title,
			subtext: subTitle,
			left: 24,
			top: 20,
		},

		grid: {
			left: 80,
			right: 40,
			top: 90,
			bottom: 80,
			height: 180, // ← 關鍵：控制「每一列的高度」
		},

		visualMap: {
			type: "piecewise",
			min: 0,
			max: 100,
			orient: "horizontal",
			right: 20,
			bottom: 10,
			text: ["高人次", "低人次"],
			inRange: {
				color: ["#F3E8FF", "#C084FC", "#6B21A8"],
			},
		},

		xAxis: {
			type: "category",
			position: "top",
			data: xLabels,
			splitArea: { show: true },
			axisLine: { show: false },
			axisTick: { show: false },
		},

		yAxis: {
			type: "category",
			data: yLabels,
			splitArea: { show: true },
			axisLine: { show: false },
			axisTick: { show: false },
		},

		series: [
			{
				type: "heatmap",
				data: seriesData,
				itemStyle: {
					borderWidth: 3,
					borderColor: "#FFFFFF",
				},
				emphasis: {
					itemStyle: {
						shadowBlur: 6,
						shadowColor: "rgba(0,0,0,0.25)",
					},
				},
			},
		],
		graphic: [
			{
				type: "text",
				right: 24, // ← 靠右
				top: 24, // ← 靠上
				style: {
					text: `資料期間：${recordTime}`,
					fill: "#64748B",
					fontSize: 14,
					fontWeight: 500,
				},
			},
		],
	};

	useEChart(chartDomRef, option);

	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});

export default MemberCheckInHeatmap;
